import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

export type UiLocation =
	| 'header'
	| 'mobile_menu'
	| 'footer'
	| 'homepage'
	| 'results'
	| 'premium'
	| 'last_minute'
	| 'first_minute'
	| 'special_offer'
	| 'active_partner';

interface DataLayerEvent {
	event: 'search' | 'widget_click' | 'destination_click';
	ui_location: UiLocation;
	widget_id?: string;
	destination?: string;
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
	private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

	public trackSearch(uiLocation: UiLocation): void {
		this.push({ event: 'search', ui_location: uiLocation });
	}

	public trackWidgetClick(widgetId: string | undefined, uiLocation: UiLocation): void {
		this.push({ event: 'widget_click', ui_location: uiLocation, widget_id: widgetId });
	}

	public trackDestinationClick(destination: string, uiLocation: UiLocation): void {
		this.push({ event: 'destination_click', ui_location: uiLocation, destination });
	}

	private push(data: DataLayerEvent): void {
		if (!this.isBrowser) {
			return;
		}
		const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
		w.dataLayer = w.dataLayer || [];
		w.dataLayer.push({ ...data });
	}
}
